
import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { ModuleBase, DEAL_STATUSES, GUEST_ACCESS_TYPES } from '@loanbossinc/component-library';
import { withRouter } from "react-router";
import { PeopleGuest } from "./peopleGuest/peopleGuest";
import { PeopleBodyView } from "./peopleBody/peopleBodyView";
import PeopleBodyEdit from "./peopleBody/peopleBodyEdit";
import { getContactNames } from "./peopleBody/peopleBody.filters";
import { mapCompanySelector } from "store/state/auth";
import AddGuestModal from '../../modals/GuestModal/AddGuestModal';

import {
  peopleDealGetById
  , peopleUpdateDeal
  , peopleGetBrokers
  , peopleGetContactsByCompany
  , peopleGetContactsByDeal
  , peopleGetGuestsByDeal
  , peopleDeleteGuestsByDeal
  , addGuestsToDeal
  , inviteGuestToTargetEmail
} from './people.store';

const ADD_GUEST_MODAL = "ADD_GUEST_MODAL";

class PeopleModule extends React.Component {
  state = {
    isEditing: false
    , openModal: { name: null, data: null }
    , portfolioDealStatuses: [DEAL_STATUSES.CLOSED, DEAL_STATUSES.REFINANCE ,DEAL_STATUSES.SOLD]
    , initGuests: false
    , selectedIds: {
      brokerCompanyId: null
      , brokerContactId: null
      , teamMemberId: null
      , assetManagerId: null
    }
  };

  componentDidMount() {
    const { dealId } = this.props.match.params;

    this.props.peopleDealGetById({ dealId });
    this.props.peopleGetBrokers({ dealId });
    this.props.peopleGetContactsByDeal({ dealId });
  }

  componentDidUpdate(prevProps) {
    const { dealId } = this.props.match.params;
    const { deal } = this.props;

    if (prevProps !== this.props && !!deal) {
      const selectedIds = this.getAssociatedDealIds();
      this.updateCompanyContacts(selectedIds.brokerCompanyId);
      this.setState({ ...this.state, selectedIds });

      if(deal && deal.dealStatusId && !this.state.initGuests){
        const accessTypeId = this.state.portfolioDealStatuses.some(x => x === deal.dealStatusId) ? GUEST_ACCESS_TYPES.PORTFOLIO_DEAL : GUEST_ACCESS_TYPES.PIPELINE_DEAL;
        this.props.peopleGetGuestsByDeal({ dealId, accessTypeId});
        this.setState({initGuests: true});
      }
    }
  }

  closeModal = () => this.setState({ openModal: { name: null, data: null } });
  openModal = (name, data = null) => this.setState({ openModal: { name, data } });
  isModalOpen = modalName => {
    const { openModal } = this.state;
    return openModal.name === modalName;
  };

  getAssociatedDealIds = () => {
    const { deal } = this.props;

    return {
      brokerCompanyId: deal.brokerCompanyId
      , brokerContactId: deal.brokerContactId
      , teamMemberId: deal.teamMemberId
      , assetManagerId: deal.assetManagerId
    };
  }

  updateCompanyContacts = (brokerCompanyId) => {
    if (!brokerCompanyId) return;
    if (brokerCompanyId === this.state.selectedIds.brokerCompanyId) return;
    this.props.peopleGetContactsByCompany({ companyId: brokerCompanyId });
  }

  toggleIsEditing = () => this.setState({ isEditing: !this.state.isEditing });
  onCancel = () => this.setState({ isEditing: false });
  onSubmit = (values) => {
    const deal = {
      id: this.props.deal.id
      , ...values
    };

    this.props.peopleUpdateDeal({
      deal
      , callback: () => {
        this.props.peopleDealGetById({ dealId: deal.id });
        this.setState({ isEditing: false });
      }
    });
  }

  onAddGuest = () => {
    this.openModal(ADD_GUEST_MODAL);
  }

  sendInvite = newGuests => {
    console.log('sendInvite', this.props);
    const { dealId } = this.props.match.params;
    const guestIds = newGuests.map(x => x.id);
    const formattedGuests = [];
    newGuests.forEach((item)=>formattedGuests.push({contact:item}));
    const accessTypeId = this.state.portfolioDealStatuses.some(x => x === this.props.deal.dealStatusId) ? GUEST_ACCESS_TYPES.PORTFOLIO_DEAL : GUEST_ACCESS_TYPES.PIPELINE_DEAL;
    this.props.addGuestsToDeal({guestIds: guestIds, dealId: dealId, accessTypeId, callback: () => this.props.peopleGetGuestsByDeal({ dealId, accessTypeId}) });        
    this.closeModal();
    const type = this.props.deal ? this.props.deal.dealStatus.value.toLowerCase() : "pipeline";
    this.props.inviteGuestToTargetEmail({
        guest: formattedGuests,
        scope: "deal",
        target: this.props.deal ? this.props.deal : null,
        targetDealStatus: type,
    });
}

  onDeleteGuest = (guest) => {
    const { dealId } = this.props.match.params;

    const payload = {
      dealId
      , ...guest
      , callback: () => this.props.peopleGetContactsByDeal({ dealId })
    }

    this.props.peopleDeleteGuestsByDeal(payload);
  }

  renderFooter = () => {
    return (
      <div style={{ borderTop: "#DADCE0 solid 1px" }}>
        <PeopleGuest
          deal={this.props.deal}
          guestList={this.props.dealGuests}
          authentication={this.props.authentication}
          onAddGuest={this.onAddGuest}
          onDeleteGuest={this.onDeleteGuest} />
      </div>
    )
  }

  renderPeopleBody = () => {
    return (
      <>
        <PeopleBodyEdit
          brokers={this.props.brokers}
          companyContacts={getContactNames(this.props.companyContacts)}
          dealContacts={getContactNames(this.props.dealContacts)}
          initialValues={this.state.selectedIds}
          brokerSelection={this.onBrokerSelection}
          onCancel={this.onCancel}
          onSubmit={this.onSubmit}
          onBrokerCompanyChange={this.updateCompanyContacts}
          isVisible={this.state.isEditing}
          authentication={this.props.authentication}
        />

        <PeopleBodyView
          brokers={this.props.brokers}
          companyContacts={getContactNames(this.props.companyContacts)}
          dealContacts={getContactNames(this.props.dealContacts)}
          selectedIds={this.state.selectedIds}
          onManageClick={this.toggleIsEditing}
          isVisible={!this.state.isEditing}
          authentication={this.props.authentication}
        />
      </>
    );
  }

  render() {
    const isPortdolioType = this.props.deal ? this.state.portfolioDealStatuses.some(x => x === this.props.deal.dealStatusId) : true;
    return (
      <ModuleBase>
        {this.renderPeopleBody()}
        {this.renderFooter()}
        <AddGuestModal
            modalOpen={this.isModalOpen(ADD_GUEST_MODAL)}
            closeModal={this.closeModal}
            sendInvite={this.sendInvite}
                        currentGuestList={this.props.dealguests}
            isPortfolio={isPortdolioType}
            isPipeline={!isPortdolioType}
                    />
      </ModuleBase>
    );
  }
}

const mapStateToProps = ({ peopleModule, authentication }, ownProps) => ({
  ...peopleModule
  , ...peopleModule.peopleModuleReducer
  , company: mapCompanySelector(authentication)
  , authentication
  , dealguests: peopleModule.dealguests ? peopleModule.dealguests[ownProps.dealId] : []
});

export default compose(
  withRouter
  , connect(mapStateToProps, {
    peopleDealGetById
    , peopleUpdateDeal
    , peopleGetBrokers
    , peopleGetContactsByCompany
    , peopleGetContactsByDeal

    , peopleGetGuestsByDeal
    , peopleDeleteGuestsByDeal
    , addGuestsToDeal
    , inviteGuestToTargetEmail
  })
)(PeopleModule);
